import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { getLeaveRequests } from "api/Employee";

interface Props {
    id?: string;
}

export const useLeaveRequests = ({id}:Props) => {

    const { data, isLoading } = useQuery<Array<any>>(
        ['leaveRequests'],
        () => {
            return getLeaveRequests({id:id});
        }, {
        onError() {
            toast.error(`Something went wrong. Please try again later.`);
        },
    }
    );

    return {
        data,
        isLoading,
    };
};
